import React from 'react';
import moment from 'moment';
import { Select, Table, Checkbox, Row, Col } from 'antd';

import { SITE_NAMES } from '../../constants/sites';

import Utility from '../_global/Utility';
import FormItem from '../_global/FormItem';
import sessions from "~/pages/Sessions";
import { dateColumns } from "~/components/registration/columns";

class UnscheduledSessions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filterByCourseID: undefined,
            filterBySite: undefined,
        };
        this.handleSessionSelected = this.handleSessionSelected.bind(this);
        this.handleSiteChange = this.handleSiteChange.bind(this);
        this.handleFilteredTitleChange = this.handleFilteredTitleChange.bind(this);
        this.validateSessions = this.validateSessions.bind(this);
    }

    validateSessions(target) {
        this.props.validateSessions(target);
    }

    handleSessionSelected(event) {
        this.props.handleSessionSelected(event);
    }

    handleSiteChange(site) {
        this.setState({ filterBySite: site });
    }

    handleFilteredTitleChange(courseID) {
        this.setState({ filterByCourseID: courseID });
    }

    render() {
        const selectedSessions = this.props.selectedSessions ?? [];
        const { sessions } = this.props;

        const nameOptions = [...new Set(sessions.map(session => session?.course?.courseID))];

        const nameDropdown = (
            <Select name={ 'day' + this.props.type } value={ this.state.filterByCourseID }
                    onChange={ this.handleFilteredTitleChange } placeholder="Filter by Course" allowClear>
                { nameOptions.map(courseID => {
                    const { course } = this.props.sessions.find(x => x?.course?.courseID === courseID)
                    return (<Select.Option key={ course.courseID }
                                           value={ course.courseID }>{ course.title }</Select.Option>)
                }) }
            </Select>
        )


        let filteredSessions = sessions;

        if (this.state.filterByCourseID) {
            filteredSessions = filteredSessions.filter(session => session.course.courseID === this.state.filterByCourseID)
        }
        if (this.state.filterBySite) {
            filteredSessions = filteredSessions.filter(session => session.site === this.state.filterBySite)
        }


        return (
            <div>
                <Row gutter={ 16 }>
                    <Col span={ 6 }>
                        <Select name={ 'day' + this.props.type } value={ this.state.filterBySite }
                                onChange={ this.handleSiteChange } placeholder="Select a Site" allowClear>
                            { Object.entries(SITE_NAMES).map(([SITE_VALUE, SITE_NAME]) => {
                                return (<Select.Option key={ SITE_VALUE }
                                                       value={ SITE_VALUE }>{ SITE_NAME }</Select.Option>)
                            }) }
                        </Select>
                    </Col>
                    <Col span={ 8 }>
                        { nameOptions.length > 1 ? nameDropdown : undefined }
                    </Col>
                </Row>
                <Row>
                    <Table
                        rowKey='sessionID'
                        dataSource={ filteredSessions }
                        columns={ dateColumns({
                            form: this.props.form,
                            handleSessionSelected: this.handleSessionSelected,
                            selectedSessions: selectedSessions,
                        }) }
                        size='middle'
                        pagination={ false }
                        bordered
                        locale={ { emptyText: 'No sessions on this date' } }
                    />
                </Row>
            </div>
        );
    }
}

export default UnscheduledSessions;
